export default {
    STRIPCHAT_MODULES_LOADED: 100,

    MEDIA_STREAM_READY: 200,
    MEDIA_STREAM_STATE_UPDATE: 202,

    STREAMING_STATS_WEBRTC_STATE_UPDATE: 300,
    STREAMING_STATS_WEBRTC_WATCH_PEER_CONNECTION: 301,
    STREAMING_STATS_WEBRTC_UNWATCH_PEER_CONNECTION: 302,
    STREAMING_STATS_WEBRTC_SEND_EVENT: 303,
    STREAMING_STATS_SET_ROOM_START_TIMER: 304,
    STREAMING_STATS_ATTACH_VIDEO_ON_ERROR: 305,
    STREAMING_STATS_DETACH_VIDEO_ON_ERROR: 306,
    STREAMING_STATS_SET_DELIVERY_START_TIMER: 307,
    STREAMING_STATS_SET_BROADCAST_START_TIMER: 308,
    STREAMING_STATS_VIDEO_DELIVERY_CAN_PLAY: 309,
    STREAMING_STATS_SET_DELIVERY_START_CONNECTION: 310,

};